import { JWayIcon } from "../../../common/assets/JWayIcons";
import HeaderTitleContent from "../../../common/components/atom/HeaderTitleContent/HeaderTitleContent";
import PageContent from "../../../common/components/atom/PageContent/PageContent";
import SectionTitle from "../../../common/components/atom/SectionTitle/SectionTitle";
import TextBox from "../../../common/components/molecule/TextBox/TextBox";
import SingleOrganization from "../../../features/organization/components/SingleOrganization";
import useSingleOrganization from "../../../features/organization/hooks/useSingleOrganization";
import useNavigationApp from "../../../navigation/useNavigationApp";
import styles from "./SingleOrganizationPage.module.scss";
import { numberFormaterString } from "../../../utils/numberFormater";

/**
 * Single Organization Page
 * @returns
 */
export default function SingleOrganizationPage() {

  return (
    <PageContent>
      <HeaderTitleContent
        withGoBackBtn
        rightContainer={<SingleOrganization.ActionBtn />}
      >
        <>
          <SingleOrganization.Name />
          <span style={{ fontSize: "1rem", marginLeft: 10, color: "gray" }}>
            <SingleOrganization.Location />
          </span>
        </>
      </HeaderTitleContent>
      <SectionTitle iconSize={9} iconType={"info"}>Informations Générales</SectionTitle>
      <div style={{ height: 300, marginBottom: 10, display: "flex", gap: 20 }}>
        <TextBox
          content={[
            {
              title: "Nom de l'organisation",
              TextRender: () => (
                <SingleOrganization.Info
                  info="organization_name"
                  emptyText="Non Renseignée"
                />
              ),
            },

            {
              title: "Rue / Avenue",
              TextRender: () => (
                <SingleOrganization.Info
                  info="organization_street"
                  emptyText="Non Renseignée"
                />
              ),
            },
            {
              title: "Ville",
              TextRender: () => (
                <SingleOrganization.Info
                  info="organization_city"
                  emptyText="Non Renseignée"
                />
              ),
            },
            {
              title: "Code Postal",
              TextRender: () => (
                <SingleOrganization.Info
                  info="organization_zip_code"
                  emptyText="Non Renseignée"
                />
              ),
            },
            {
              title: "Pays",
              TextRender: () => (
                <SingleOrganization.Info
                  info="organization_country"
                  emptyText="Non Renseignée"
                />
              ),
            },
          ]}
        />
        <TextBox
          content={[
            {
              title: "Créé le",
              TextRender: () => (
                <SingleOrganization.Info info="organization_create_at" />
              ),
            },

            {
              title: "Modifié le",
              TextRender: () => (
                <SingleOrganization.Info info="organization_update_at" />
              ),
            },
            {
              title: "Nombre d'utilisateurs",
              TextRender: () => (
                <SingleOrganization.Info info="organization_nb_users" />
              ),
            },
            {/*}
            {
              title: "Statut",
              TextRender: () => (
                <SingleOrganization.Info info="organization_status" styled />
              ),
            },
            */}
          ]}
        />
      </div>
      <div style={{ height: 50 }} />
      <WalletWidget />
      <div style={{ height: 50 }} />
      <SectionTitle iconType={"peoples"} iconSize={18}>
        Utilisateurs de <SingleOrganization.Info info="organization_name" />
      </SectionTitle>
      <div style={{ width: "100%", maxWidth: 1000 }}>
        <SingleOrganization.UserList pageSize={5} />
      </div>
      <div className={styles["divider"]} style={{ height: 80 }} />
      <SectionTitle iconType={"link-crooked"}>
        Lien d'invitations de{" "}
        <SingleOrganization.Info info="organization_name" />
      </SectionTitle>
      <div style={{ width: "100%", maxWidth: 1000 }}>
        <SingleOrganization.CreateUserTokenList pageSize={5} />
      </div>
      <div style={{ height: 50 }} />
      <SectionTitle iconType={"admin"}>Action</SectionTitle>

      <div style={{display: "flex", gap: 20, marginBottom: 50}}>
      <SingleOrganization.AddNewCreateUserTokenModalBtn />



      </div>


      <div className={styles["divider"]} style={{ height: 100 }} />
    </PageContent>
  );
}

const WalletWidget = () => {
  const {singleWalletQuery} = useSingleOrganization();
  const navigate = useNavigationApp();
  return <>
  
          
          {singleWalletQuery.data &&

            <TextBox
                  style={{ height: "150px", width: "clamp(150px, 50%, 300px)" }}
                  content={[
                    {
                      title: "Portefeuille",
                      ItemRender: () => (
                        <p
                          style={{
                            fontSize: "clamp(2rem, 2.5vw, 3rem)",
                            display: "flex",
                            margin: 0,
                            padding: 0,
                          }}
                        >
                          {numberFormaterString(singleWalletQuery.data.wallet_amount)}{" "}
                          <span
                            style={{
                              fontSize: "0.9rem",
                              marginTop: "10px",
                              marginLeft: "10px",
                            }}
                          >
                            {singleWalletQuery.data.wallet_currency}
                          </span>
                        </p>
                      ),
                      LeftIconRender: () => (
                        <JWayIcon
                          type="wallet"
                          size={15}
                          color="rgb(162, 162, 162)"
                        />
                      ),
                    },
                  ]}
                  labelBtn="Voir"
                  onClick={() =>
                    navigate.goToWalletOrgnization(
                      singleWalletQuery.data.wallet_organization,
                      singleWalletQuery.data.wallet_id
                    )
                  }
                />
  }
  </>
}
